import React from 'react';
import MenuButtonFilter from '@app/component/menu/MenuButtonFilter';
import ReviewsFilterInput from '@app/model/review/input/ReviewsFilterInput';
import DataProvider from '@app/model/_common/DataProvider';
import { PROVIDER_DATA } from '@app/component/provider/FindProviderData';

type ReviewsProviderButtonFilterProps = {
	filter: ReviewsFilterInput;
	onFilter: (filter: ReviewsFilterInput) => void;
};

const ReviewsProviderButtonFilter = React.memo(
	function ReviewsProviderButtonFilter({ filter, onFilter }: ReviewsProviderButtonFilterProps) {

		const menuItems = [
			{
				value: undefined,
				name: 'Any Provider',
				icon: undefined,
			},{
				value: DataProvider.BOOKING,
				name: PROVIDER_DATA.BOOKING.name,
				icon: PROVIDER_DATA.BOOKING.icon,
			},
			{
				value: DataProvider.EXPEDIA,
				name: PROVIDER_DATA.EXPEDIA.name,
				icon: PROVIDER_DATA.EXPEDIA.icon,
			},
		];

		const onSelect = (value: DataProvider) => {
			onFilter({
				...filter,
				provider: value,
			});
		};

		return <MenuButtonFilter menuItems={menuItems} selectedValue={filter.provider} onSelect={onSelect} />;
	},
);

export default ReviewsProviderButtonFilter;